import "./ErrorPage.scss";
import { Box } from "../../../components/styled-system/Box";
import { Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { fetchErrorStatistics } from "../../../api/old-vine-registry-api";
import { ErrorStatistics } from "../../../api/models";

const TD = ({ children }: { children: React.ReactNode }) => (
  <td>
    <Box height="100%" display="flex" alignItems="center">
      {children}
    </Box>
  </td>
);

export const ErrorsTable: React.FC = () => {
  const [stats, setStats] = useState<ErrorStatistics | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchErrorStatistics()
      .then(setStats)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    document.title = "Errors | Old Vine Registry";
    return () => { document.title = "Old Vine Registry"; };
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="200px">
        <Spinner animation="border" role="status" />
      </Box>
    );
  }

  const monthlyErrors = stats?.monthlyErrors || [];
  const latestErrors = stats?.latestErrors || [];

  return (
    <div className="admin-panel">
      {/* Errors per month bar chart */}
      <div style={{ marginBottom: "32px" }}>
        <h3 className="title-small">Errors per Month — Last 12 Months</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={monthlyErrors}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" fontSize={12} />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="count" fill="#c62828" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Last 20 errors table */}
      <h3 className="title-small">Latest 20 Errors</h3>
      <Table hover size="sm" className="vineyard-table input-text u-mt-large">
        <thead>
          <tr>
            <th>Id</th>
            <th>Date</th>
            <th>Message</th>
            <th>Exception</th>
          </tr>
        </thead>
        <tbody>
          {latestErrors.map((row, i) => (
            <tr key={i}>
              <TD>{row.id}</TD>
              <TD>{row.createdDate.toString()}</TD>
              <TD><span className="break-text">{row.customMessage}</span></TD>
              <TD><span className="break-text">{row.exception}</span></TD>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
